module.exports = __webpack_public_path__ + "img/COUCOU_GRIS_GIF_COMPRESSED_2.81f713fa.gif";